export default {
  install(Vue, options) {
    Vue.prototype.showAlert = function (type = 'success', message = '操作成功！', showClose = false, dangerouslyUseHTMLString = true, offset = 20, duration = 3000
    ) {
      this.$message({
        type: type,
        message: message,
        showClose: showClose,
        dangerouslyUseHTMLString: dangerouslyUseHTMLString,
        offset: offset,
        duration: duration
      })
    }
    // patch请求
    Vue.prototype.$patch = function (
      url,
      parmas,
      successCallBack,
      errorCallBack
    ) {
      this.$axios
        .patch(url, parmas)
        .then(res => {
          successCallBack(res.data)
        })
        .catch(err => {
          ;(errorCallBack && errorCallBack()) || this.showAlert('error', err)
        })
    }
    // delete请求
    Vue.prototype.$del = function (url, parmas, successCallBack, errorCallBack) {
      // console.log(parmas, 'params')
      this.$axios
        .delete(url, { data: parmas })
        .then(res => {
          successCallBack(res.data)
        })
        .catch(err => {
          ;(errorCallBack && errorCallBack()) || this.showAlert('error', err)
        })
    }
    // put请求
    Vue.prototype.$put = function (url, parmas, successCallBack, errorCallBack) {
      this.$axios
        .put(url, parmas)
        .then(res => {
          successCallBack(res.data)
        })
        .catch(err => {
          ;(errorCallBack && errorCallBack()) || this.showAlert('error', err)
        })
    }
    // post请求
    Vue.prototype.$post = function (
      url,
      parmas,
      successCallBack,
      errorCallBack
    ) {
      this.$axios
        .post(url, parmas)
        .then(res => {
          successCallBack(res.data)
        })
        .catch(err => {
          ;(errorCallBack && errorCallBack()) || this.showAlert('error', err)
        })
    }

    // get请求
    Vue.prototype.$get = function (url, parmas, successCallBack, errorCallBack) {
      this.$axios
        .get(url, parmas, {
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrftoken'
        })
        .then(res => {
          successCallBack(res.data)
        })
        .catch(err => {
          ;(errorCallBack && errorCallBack()) || this.showAlert('error', err)
        })
    }

    // 获取随机颜色
    Vue.prototype.getRandomColor = function () {
      return (
        '#' +
        ('333333' + ((Math.random() * 0x15720922) << 0).toString(16)).substr(-6)
      )
    }

    // 获取默认分页配置
    Vue.prototype.getPageConfig = function (res, params) {
      return {
        pageNo: params.pageNo || 0,
        pagerCount: params.pagerCount || 10,
        pageSize: params.pageSize || 10,
        pageSizes: params.pageSizes || [2, 5, 10, 15, 20, 25, 30],
        total: res.data.total || 0
      }
    }

    // 检查检索项
    Vue.prototype.checkSearchParam = function (type, value) {
      // if (value !== '' && type === '') {
      //   this.$message({
      //     message: '请选择' + value + '对应的检索类别',
      //     type: 'warning'
      //   })
      // } else if (type !== '' && value === '') {
      if (type !== '' && value.length === 0) {
        this.$message({
          message: 'Please fill in the filtering content of ' + type + ' or remove ' + type + 'condition.',
          type: 'warning'
        })
      } else {
        return true
      }
    }

    Vue.prototype.multiFilter = function (array, filters) {
      const filterKeys = Object.keys(filters)
      return array.filter(item => {
        return filterKeys.every(key => {
          if (!filters[key].length) return true
          return !!~filters[key].indexOf(item[key])
        })
      })
    }

    // 设置localStorage
    Vue.prototype.setStore = function (name, content) {
      if (!name) return
      if (typeof content !== 'string') {
        content = JSON.stringify(content)
      }
      window.localStorage.setItem(name, content)
    }

    // 获取localStorage
    Vue.prototype.getStore = function (name) {
      if (!name) return
      return window.localStorage.getItem(name)
    }

    // 删除localStorage
    Vue.prototype.removeStore = function (name) {
      if (!name) return
      window.localStorage.removeItem(name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/util/vue-util.js